import { getFormattedDateString } from "../../lib";
import "./style.css";
import { Button } from "primereact/button";

export const LicenseBar = ({ clientLicenseObj = {} }) => {
  return (
    <div className="LicenseBar">
      <div>
        <h3 className="inline">Klient: </h3>
        <span>{clientLicenseObj?.domain}</span>
      </div>

      <div>
        <h3 className="inline">Typ licencji: </h3>
        <span>{clientLicenseObj?.type}</span>
      </div>
      <div>
        <h3 className="inline">Koniec licencji: </h3>
        <span>
          {getFormattedDateString(new Date(clientLicenseObj?.dateEnd?.date))}
        </span>
      </div>
      <a href="https://beupsoft.pl/store/" target="_blank" rel="noreferrer">
        <Button icon="pi pi-shopping-cart" />
      </a>
    </div>
  );
};
